// extracted by mini-css-extract-plugin
export default {"btn":"TheButton_btn_e6Vux","warning":"TheButton_warning_rBAbO"};